var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.room)?_c('v-btn',{staticClass:"mb-2",attrs:{"color":"primary","block":""},on:{"click":_vm.go}},[_vm._v("Room Monitor")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }